import { requestWithToken } from '../../../utilities/request';

/**
 * 作業員顔情報取得API
 * @param {number} workerId
 * @param {object} param
 */
const fetchFacePicture = (workerId, param) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/worker_image/${workerId}`,
    params: param,
  });
};

/**
 * 作業者顔情報保存API
 * @param {object} param
 */
const updateFacePicture = param => {
  return requestWithToken({
    method: 'POST',
    url: '/api/private/ccus/workers/face_image_upload',
    headers: { 'content-type': 'multipart/form-data' },
    data: param,
  });
};

const WorkerImageApi = {
  fetchFacePicture,
  updateFacePicture,
};

export default WorkerImageApi;



// WEBPACK FOOTER //
// ./src/services/workers/workerImage/WorkerImageApi.js